<template>
  <div class="search">
    <!-- banner部分 -->
    <div class="search-banner">
      <div>
        <h2>搜索结果</h2>
      </div>
    </div>
    <!-- 内容部分 -->
    <div class="container">
      <ul class="list">
        <li>
          <h3>智慧校园建设团队及其特点</h3>
          <h4>
            智慧校园指的是以物联网为基础的智慧化的校园工作、学习和生活一体化环境，这个一体化环境以各种应用服务系统为载体，将教学、科研、管理
            和校园生活进行充分融合。2010年，在信息化“十二五”规划中，浙江大学提出建设一个“令人激动”的“智慧校园”。这幅蓝图描绘的是：无处不在
            的网络学习、融合创新的网络科研、透明高效的校务治理、丰富多彩的校园文化、方便周到的校园生活。简而言之，“要做一个安全、稳定、环保、节
            能的校园。”2018年6月7日，国家标准《智慧校园总体框架》（Smart campus
            overall framework）发布。
          </h4>
          <p>
            <span>2022-01-23</span>
            <span>公司新闻</span>
          </p>
        </li>
        <li>
          <h3>智慧校园解决方案</h3>
          <h4>
            智慧校园指的是以物联网为基础的智慧化的校园工作、学习和生活一体化环境，这个一体化环境以各种应用服务系统为载体，将教学、科研、管理
            和校园生活进行充分融合。2010年，在信息化“十二五”规划中，浙江大学提出建设一个“令人激动”的“智慧校园”。这幅蓝图描绘的是：无处不在
            的网络学习、融合创新的网络科研、透明高效的校务治理、丰富多彩的校园文化、方便周到的校园生活。简而言之，“要做一个安全、稳定、环保、节
            能的校园。”2018年6月7日，国家标准《智慧校园总体框架》（Smart campus
            overall framework）发布。
          </h4>
          <p>
            <span>2022-01-23</span>
            <span>解决方案</span>
          </p>
        </li>
        <li>
          <h3>智慧校园建设团队及其特点</h3>
          <h4>
            智慧校园指的是以物联网为基础的智慧化的校园工作、学习和生活一体化环境，这个一体化环境以各种应用服务系统为载体，将教学、科研、管理
            和校园生活进行充分融合。2010年，在信息化“十二五”规划中，浙江大学提出建设一个“令人激动”的“智慧校园”。这幅蓝图描绘的是：无处不在
            的网络学习、融合创新的网络科研、透明高效的校务治理、丰富多彩的校园文化、方便周到的校园生活。简而言之，“要做一个安全、稳定、环保、节
            能的校园。”2018年6月7日，国家标准《智慧校园总体框架》（Smart campus
            overall framework）发布。
          </h4>
          <p>
            <span>2022-01-23</span>
            <span>公司新闻</span>
          </p>
        </li>
        <li>
          <h3>智慧校园解决方案</h3>
          <h4>
            智慧校园指的是以物联网为基础的智慧化的校园工作、学习和生活一体化环境，这个一体化环境以各种应用服务系统为载体，将教学、科研、管理
            和校园生活进行充分融合。2010年，在信息化“十二五”规划中，浙江大学提出建设一个“令人激动”的“智慧校园”。这幅蓝图描绘的是：无处不在
            的网络学习、融合创新的网络科研、透明高效的校务治理、丰富多彩的校园文化、方便周到的校园生活。简而言之，“要做一个安全、稳定、环保、节
            能的校园。”2018年6月7日，国家标准《智慧校园总体框架》（Smart campus
            overall framework）发布。
          </h4>
          <p>
            <span>2022-01-23</span>
            <span>解决方案</span>
          </p>
        </li>
        <li>
          <h3>智慧校园建设团队及其特点</h3>
          <h4>
            智慧校园指的是以物联网为基础的智慧化的校园工作、学习和生活一体化环境，这个一体化环境以各种应用服务系统为载体，将教学、科研、管理
            和校园生活进行充分融合。2010年，在信息化“十二五”规划中，浙江大学提出建设一个“令人激动”的“智慧校园”。这幅蓝图描绘的是：无处不在
            的网络学习、融合创新的网络科研、透明高效的校务治理、丰富多彩的校园文化、方便周到的校园生活。简而言之，“要做一个安全、稳定、环保、节
            能的校园。”2018年6月7日，国家标准《智慧校园总体框架》（Smart campus
            overall framework）发布。
          </h4>
          <p>
            <span>2022-01-23</span>
            <span>公司新闻</span>
          </p>
        </li>
        <li>
          <h3>智慧校园解决方案</h3>
          <h4>
            智慧校园指的是以物联网为基础的智慧化的校园工作、学习和生活一体化环境，这个一体化环境以各种应用服务系统为载体，将教学、科研、管理
            和校园生活进行充分融合。2010年，在信息化“十二五”规划中，浙江大学提出建设一个“令人激动”的“智慧校园”。这幅蓝图描绘的是：无处不在
            的网络学习、融合创新的网络科研、透明高效的校务治理、丰富多彩的校园文化、方便周到的校园生活。简而言之，“要做一个安全、稳定、环保、节
            能的校园。”2018年6月7日，国家标准《智慧校园总体框架》（Smart campus
            overall framework）发布。
          </h4>
          <p>
            <span>2022-01-23</span>
            <span>解决方案</span>
          </p>
        </li>
      </ul>
      <!-- 分页部分 -->
      <div class="news-page container clearfix">
        <ul>
          <li class="back-index" @click="tofirst">
            <a href="javascript:void(0)">首页</a>
          </li>
          <li class="back-index" @click="toprev">
            <a href="javascript:void(0)">上一页</a>
          </li>
          <li
            :class="index == current1 ? 'current' : ''"
            @click="changeTab1(index)"
            v-for="(item, index) in pageList"
            :key="index"
          >
            <a href="javascript:void(0)">{{ item }}</a>
          </li>
          <li class="back-index" @click="tonext">
            <a href="javascript:void(0)">下一页</a>
          </li>
          <li class="back-index" @click="toend">
            <a href="javascript:void(0)">末页</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
      name: 'Searchdetail',
  data() {
    return {
      tabList: ['全部', '公司新闻', '公司活动'],
      pageList: ['1', '2', '3'],
      current: 0,
      current1: 0,
    }
  },
  methods: {
    changeTab(index) {
      this.current = index
      this.current1 = 0
    },
    changeTab1(index) {
      this.current1 = index
    },
    toprev() {
      if (this.current1 == 0) {
        this.current1 == 0
      } else {
        this.current1 -= 1
      }
    },
    tonext() {
      if (this.current1 == 2) {
        this.current1 = 2
      } else {
        this.current1 += 1
      }
    },
    tofirst() {
      this.current1 = 0
    },
    toend() {
      this.current1 = 2
    },
  },
}
</script>
<style scoped>
.search-banner {
  width: 100%;
  height: 594px;
  line-height: 594px;
  background: #000;
}
.search-banner div {
  width: 100%;
  height: 100%;
  background: url(../../assets/img/background_Image.png) no-repeat;
  background-size: cover;
}
.search-banner h2 {
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.list li {
  margin-top: 101px;
}
.list li h3 {
  margin-bottom: 40px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.list li h4 {
  margin-bottom: 39px;
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.7;
}
.list li p {
  font-size: 18px;
  font-weight: 400;
  color: #cccccc;
}
.list li p span:nth-child(2) {
  margin-left: 39px;
}
.news-page {
  padding: 85px 0;
  font-size: 18px;
  font-weight: 400;
  color: #333;
}
.news-page ul li {
  float: left;
  margin-right: 20px;
}
.news-page ul li a {
  display: block;
  padding: 20px 25px;
  background: #ffffff;
  box-shadow: 0px 3px 13px 5px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
}
.news-page ul li.current a {
  background: #0076de;
  color: #fff;
}
.back-index {
  width: 140px;
}
.news-page ul li:nth-child(1) {
  margin-left: 100px;
}
.back-index a {
  text-align: center;
}
</style>
